import React, { useEffect, useState } from 'react';
import API from '../utils/api';
import safeStorage from '../utils/safeStorage';

// Smart bedtime-reminder suggestion. Reads the family's actual story times and
// proposes a reminder time (enable a new one, or shift an existing one to match
// when they really read). Accepting calls the normal reminder-settings update.
// Dismissals are remembered for 30 days so it doesn't nag.
const DISMISS_KEY = 'db_reminder_suggestion_dismissed';
const DISMISS_MS = 30 * 24 * 60 * 60 * 1000;

const ReminderSuggestionCard = () => {
  const [suggestion, setSuggestion] = useState(null);
  const [state, setState] = useState('idle'); // idle | saving | done

  useEffect(() => {
    const dismissed = parseInt(safeStorage.getItem(DISMISS_KEY) || '0', 10);
    if (Date.now() - dismissed < DISMISS_MS) return;
    API.get('/reminders/suggestion')
      .then(res => { if (res.data.suggestion) setSuggestion(res.data.suggestion); })
      .catch(() => {});
  }, []);

  if (!suggestion || state === 'done') return null;

  const accept = async () => {
    setState('saving');
    try {
      await API.put('/reminders/settings', { enabled: true, time: suggestion.suggestedTime });
      setState('done');
    } catch {
      setState('idle');
    }
  };

  const dismiss = () => {
    safeStorage.setItem(DISMISS_KEY, String(Date.now()));
    setSuggestion(null);
  };

  // Pretty 12-hour label for the button from the 24h suggestedTime
  const [h, m] = suggestion.suggestedTime.split(':').map(Number);
  const label = `${((h % 12) || 12)}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;

  return (
    <div className="rounded-4 p-4 mb-4 d-flex flex-column flex-md-row align-items-md-center gap-3"
      style={{ background: 'var(--blue-section)', border: '1px solid var(--border-blue)' }}>
      <div className="flex-grow-1">
        <div className="fw-bold mb-1" style={{ color: 'var(--text-main)', fontSize: '15px', fontFamily: "'Fredoka One',cursive" }}>
          🕐 Smarter bedtime reminder
        </div>
        <div style={{ color: 'var(--text-muted2)', fontSize: '14px', lineHeight: 1.6 }}>
          {suggestion.message}
        </div>
      </div>
      <div className="d-flex gap-2 flex-shrink-0">
        <button type="button" className="btn btn-dream rounded-pill px-3 fw-semibold" onClick={accept} disabled={state === 'saving'}>
          {state === 'saving'
            ? <><span className="spinner-border spinner-border-sm me-1" style={{ width: '12px', height: '12px', borderWidth: '2px' }}></span>Setting…</>
            : <>Set {label}</>}
        </button>
        <button type="button" className="btn btn-link text-decoration-none" style={{ color: 'var(--text-soft)', fontSize: '14px' }} onClick={dismiss}>
          Not now
        </button>
      </div>
    </div>
  );
};

export default ReminderSuggestionCard;
